module.exports = __webpack_public_path__ + "img/completion4.403057a9.svg";